import { Message } from 'element-ui'
import { downloadBlobFile } from './index'

export default {
  fetchWrapper(fetch, { type, success, fail }) {
    fetch
      .then((res) => {
        console.log(type, res)
        switch (type) {
            case 'list':
              if (
                res.data.result === 0 ||
              res.data.errmsg === 'ok' ||
              res.data.result === -13 ||
              res.data.result === 13
              ) {
                success && success(res)
              } else {
                Message.error(res.data.message || res.data.errmsg)
                fail && fail()
              }
              break
            case 'info':
              if (res.data.result === 0 || res.data.errmsg === 'ok' || res.data.result === -13 || res.data.result === 13) {
                success && success(res)
              } else {
                Message.error(res.data.message || res.data.errmsg)
                fail && fail()
              }
              break
            case 'action':
              if (res.data.result === 0 || res.data.errmsg === 'ok') {
                success && success(res)
              } else {
                Message.error(res.data.message || res.data.errmsg)
                fail && fail()
              }
              break
            case 'file':
              downloadBlobFile(res)
              success && success()
              break
            case 'blob':
              success && success(res)
              break
            default:
              success && success(res)
              break
        }
      })
      .catch((err) => {
        console.dir(err)
        Message.error(err.message)
        fail && fail(err)
      })
  }
}
